module.exports = __webpack_public_path__ + "img/Group 1315.7bb97ad9.png";